var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNewspaper = function SvgNewspaper(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15H18",
    stroke: "#1B1F3B",
    strokeWidth: 0.781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.5h7.031V19H4.562C3.7 19 3 18.3 3 17.437V6.5Z",
    fill: "#CBD4E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19c.359 0 .703-.158.956-.44.254-.28.396-.662.396-1.06V4.75c0-.199.071-.39.198-.53A.644.644 0 0 1 6.028 4h13.296c.18 0 .351.079.478.22.127.14.198.331.198.53V17.5c0 .398-.142.78-.396 1.06-.254.282-.598.44-.956.44H4Z",
    fill: "#1B2230"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 8.5H17M9.25 11.5H17",
    stroke: "#fff",
    strokeWidth: 0.781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNewspaper;